import { ApiDateFormat, DisplayDateFormat, formatLocalDate } from '@/utils/formatDate';

// For reducer queries

/**
 * @deprecated Use Action or PayloadAction from App\utils\stateManagementModels instead.
 */
interface Action<T> {
  type: T;
  payload?: any;
}

interface ErrorModel {
  error: boolean;
  fields: Array<FieldError>;
}

interface FieldError {
  name: string;
  errors: Array<string>;
}

/**
 * Boilerplate for the queries pattern.
 * @deprecated Use QueryState<T> from App\utils\stateManagementModels instead
 */
interface QueryState<T> {
  readonly queries: Array<Action<T>>;
}

const getFieldError = (fieldName: string, fieldErrors: Array<FieldError>) => {
  // Try to find and return first error for the field with this name
  const matchingField = fieldErrors.find((fieldError) => fieldError.name === fieldName);
  if (matchingField && matchingField.errors.length > 0) {
    return matchingField.errors[0];
  }

  return null;
};

const areScalarArraysEqualIgnoreOrder = (array1: Array<any>, array2: Array<any>): boolean => {
  if (array1.length != array2.length) {
    return false;
  }

  const array2Sorted = array2.slice().sort();

  return array1
    .slice()
    .sort()
    .every((value, index) => value === array2Sorted[index]);
};

/// any arrays items are considered to be of primitive type
/// arrays are compared ignoring order

function areObjectsEqual<T>(object1: T, object2: T, ignoredFields?: Array<string>): boolean {
  if (object1 === object2) {
    return true;
  }

  if (!(object1 instanceof Object) || !(object2 instanceof Object)) {
    return false;
  }

  if (Array.isArray(object1) && Array.isArray(object2)) {
    return areScalarArraysEqualIgnoreOrder(object1, object2);
  }

  const uniqueKeys = Object.keys(object1)
    .concat(Object.keys(object2))
    .filter((value, index, self) => self.indexOf(value) === index);

  for (let i = 0; i <= uniqueKeys.length; i += 1) {
    const key = uniqueKeys[i];

    const shouldSkip = ignoredFields?.some((field) => field === key);
    if (!shouldSkip) {
      const value1 = object1[key];
      const value2 = object2[key];

      if (!areObjectsEqual(value1, value2)) {
        return false;
      }
    }
  }

  return true;
}

function getFixedDate(value: string | Date): Date {
  let fixedDate: Date;
  if (!(value instanceof Date)) {
    const objectDate = new Date(value);
    fixedDate = new Date(objectDate.getTime() + objectDate.getTimezoneOffset() * 60000);
  } else {
    fixedDate = value;
  }

  return fixedDate;
}

function dateToYYYYMMDD(date: string | Date, delimiter = '-'): string {
  const fixedDate = getFixedDate(date);
  return formatLocalDate(fixedDate, ApiDateFormat.DateOnly);
}

function dateToString(date: string | Date): string {
  const fixedDate = getFixedDate(date);
  const result = formatLocalDate(fixedDate, DisplayDateFormat.ShortDate);
  return result;
}

export {
  Action,
  ErrorModel,
  FieldError,
  QueryState,
  getFieldError,
  areScalarArraysEqualIgnoreOrder,
  areObjectsEqual,
  dateToYYYYMMDD,
  dateToString,
};
